<!-- File: components/EditorToolbar.vue -->
<template>
    <!-- Header & Size -->
    <span class="ql-formats">
        <select class="ql-header border rounded px-1 py-0.5 text-sm">
            <option value="1">Heading 1</option>
            <option value="2">Heading 2</option>
            <option value="3">Heading 3</option>
            <option selected>Normal</option>
        </select>
    </span>

    <!-- Basic styles -->
    <span class="ql-formats">
        <button v-tooltip.bottom="'Bold'" class="ql-bold"></button>
        <button v-tooltip.bottom="'Italic'" class="ql-italic"></button>
        <button v-tooltip.bottom="'Underline'" class="ql-underline"></button>
        <button v-tooltip.bottom="'Strike'" class="ql-strike"></button>
    </span>

    <!-- Block types / Lists -->
    <span class="ql-formats">
        <button v-tooltip.bottom="'Blockquote'" class="ql-blockquote"></button>
        <button v-tooltip.bottom="'Code Block'" class="ql-code-block"></button>
        <button v-tooltip.bottom="'Ordered List'" class="ql-list" value="ordered"></button>
        <button v-tooltip.bottom="'Bullet List'" class="ql-list" value="bullet"></button>
        <button v-tooltip.bottom="'Indent'" class="ql-indent" value="-1"></button>
        <button v-tooltip.bottom="'Outdent'" class="ql-indent" value="+1"></button>
    </span>

    <!-- Colors & Background -->
    <span class="ql-formats">
        <select class="ql-color border rounded px-1 py-0.5 text-sm"></select>
        <select class="ql-background border rounded px-1 py-0.5 text-sm"></select>
    </span>

    <!-- Align / Clean -->
    <span class="ql-formats">
        <select class="ql-align border rounded px-1 py-0.5 text-sm">
            <option selected></option>
            <option value="center"></option>
            <option value="right"></option>
            <option value="justify"></option>
        </select>
        <button v-tooltip.bottom="'Clean Formatting'" class="ql-clean"></button>
    </span>
</template>

<script setup>
</script>